<template lang="pug">
  .component-role-edit
    .row.column.card.pt-2
      .row
        .column
          label Role Name
            input(type="text", v-model="role.name")
          label Role Description
            input(type="text", v-model="role.description")

        .column
          label Permissions
            select(multiple, v-model="role.menu")
              //option(:value="null") --
              option(value="menu_overview") Overview
              option(value="menu_todo") Todo's
              option(value="menu_customers") Customers
              option(value="menu_booking") Booking
              option(value="menu_billing") Billing
              option(value="menu_assets") Assets
              option(value="menu_support") Support
              //option(value="menu_configuration") Configuration
      //.row
        .column
          pre {{role.permissions}}
          //pre {{permissions}}
          //pre {{permissionsMesh}}
        .column
          pre {{selectedMesh}}
      .row.column
        ActionButton(:action="save") Save


</template>

<script>
  import ActionButton from '../../components/structure/ui/ActionButton'
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'

  export default {
    name: 'RoleEdit',
    components: {ActionButton},
    data() {
      return {
        permissions: [],
        role: {
          name: null,
          description: null,
          permissions: [],
          menu: []
        },
        available: [],
        defaultPermissions: [
          'profile-user',
          'drivers-select-list',
          'clients-select-list',
          'plans-select-list',
          'categories-select-list',
          'vehicles-select-list',
          'vehicle-slots-select-list',
          'parking-lots-select-list',
          'reporting-types-select-list',
          'reservation-rates-select-list',
          'distance-rates-select-list',
          'time-rates-select-list',
          'vehicle-brands-select-list',
          'search-search',
        ]
      }
    },
    created() {
      KeplerBackofficeSdk.roles.list().permissions((data) => {
        this.available = data
      })

      if (this.$route.params.id !== undefined) {

        this.role.name = this.item.name
        this.role.description = this.item.description

        this.item.permissions.forEach((item) => {

          if (item.name.startsWith('menu')) {
            this.role.menu.push(item.name)
          } else {
            this.role.permissions.push(item.name)
          }

        })

      }
    },
    methods: {
      save() {
        const permissions = [...this.selectedMesh, ...this.defaultPermissions]
        this.role.permissions = []
        this.available.forEach((item) => {
          permissions.forEach((selected) => {
            if (item.name === selected) {
              this.role.permissions.push(item.id)
            }
          })
        })

        if (this.$route.params.id !== undefined) {
          return KeplerBackofficeSdk.roles.select(this.item).edit(this.role, () => {
            MaggieHelper.notification('Done', 'Role updated')
            this.$router.push({name:'roles'})
          })
        }

        return KeplerBackofficeSdk.roles.make(this.role, (data) => {
          MaggieHelper.notification('Done', 'Role created')
          this.$router.push({name:'roles'})
        })
      }
    },
    computed: {
      selectedMesh() {
        //let mesh = [...this.requiredPermissions, ...this.permissions]
        let mesh = []
        this.role.menu.forEach((item, key) => {
          mesh.push(...this.permissionsMesh[item])
        })

        return mesh
      },
      permissionsMesh() {
        return {
          'menu_overview': [
            'charged-reservations-charts',
            'client-registrations-charts',
            'driven-distance-charts',
            'driver-registrations-charts',
            'index-reporting',
            'index-reservations',
            'index-vehicle-alarm',
            'index-vehicles',
            'index-zone',
            'vehicle-distance-charts',
            'vehicle-reservations-charts',
          ],
          'menu_todo': [
            'activate-clients',
            'add-attachment-driver-licenses',
            'approval-client',
            'approval-document',
            'approval-driver',
            'approve-driver-licenses',
            'approve-drivers',
            'balance-billing',
            'delete-clients',
            'delete-driver-licenses',
            'get-clients',
            'get-drivers-clients',
            'index-document-type',
            'licenses-drivers',
            'patch-document',
            'refuse-driver-licenses',
          ],
          'menu_customers': [
            'all-cards',
            'approve-drivers',
            'availability-vehicles',
            'cards-drivers',
            'clients-reports',
            'create-cards',
            'driver-index-reservations',
            'edit-drivers',
            'get-driver-subscriptions-subscriptions',
            'get-drivers',
            'get-subscriptions-subscriptions',
            'index-client-types',
            'index-clients',
            'index-document-type',
            'index-drivers',
            'index-log',
            'licenses-drivers',
            'reactivate-drivers',
            'reset-password-driver',
            'send-reset-driver',
            'store-document',
            'store-driver',
            'suspend-drivers',
            'tocs-driver',
            'get-clients',
            'get-drivers-clients',
            'index-reservations',
            'plan-select-list',
            'balance-billing',
            'get-client-subscriptions-subscriptions',
            'index-transactions',
          ],
          'menu_booking': [
            'availability-vehicles',
            'complete-reservation',
            'debug-info-reservations',
            'delete-reservation',
            'deposits-reservation',
            'edit-reservation',
            'get-reservations',
            'index-note',
            'index-reservations',
            'new-book-reservation',
            'open-reservation',
            'resend-to-vehicle-reservation',
            'reservations-reports',
            'route-reservation',
            'search-vehicle-slots',
            'void-reservation-reservation',
            'vehicles-select-list',
          ],
          'menu_billing': [
            'get-clients',
            'get-invoices',
            'index-invoices',
            'invoices-reports',
            'pay-invoices',
            'payed-invoices',
            'void-invoices',
            'index-transactions',
          ],
          'menu_assets': [
            'availability-vehicles',
            'close-vehicle',
            'compute-roi-vehicle',
            'create-parking-slot',
            'create-vehicle-categories',
            'create-vehicle-types',
            'data-vehicles',
            'delete-note',
            'delete-vehicle-attributes',
            'delete-zone',
            'deposits-reservation',
            'disable-vehicle-slots',
            'dismiss-vehicle-slot',
            'drain-vehicle-slot',
            'edit-vehicle-categories',
            'get-parking-groups',
            'get-parking-lots',
            'get-reservations',
            'get-vehicle-slots',
            'get-vehicles',
            'index-instruction',
            'index-note',
            'index-parking-groups',
            'index-public-file',
            'index-reporting',
            'index-reservations',
            'index-vehicle-attributes',
            'index-vehicle-categories',
            'index-vehicle-instruction',
            'index-vehicle-slot',
            'index-vehicle-types',
            'index-vehicles',
            'index-zone',
            'list-attributes-vehicle',
            'managers-vehicle-hardware',
            'movements-vehicles',
            'open-vehicle',
            'patch-vehicle-attributes',
            'patch-zone',
            'put-note',
            'route-reservation',
            'show-zone',
            'slots-parking-lot',
            'store-vehicle-attributes',
            'swap-vehicle-slot',
            'types-asset-costs',
            'vehicles-reports',
            'vehicles-reports',
            'view-vehicle-attributes',
          ],
          'menu_support': [
            'create-reporting',
            'delete-instruction',
            'edit-reporting',
            'get-reporting',
            'get-vehicles',
            'index-instruction',
            'index-reporting',
            'patch-instruction',
            'patch-reporting-type',
            'types-reporting',
            'update-status-reporting',
            'store-reporting-type',
            'view-instruction',
          ],
          'menu_config': [
            'index-client-types',
            'index-document-requirement',
            'index-document-type',
            'index-federation',
            'index-group',
            'index-plan',
            'index-policy',
            'index-reservation-rate',
            'index-role',
            'index-toc',
            'index-toc-type',
            'list-commands-console',
          ],
        }
      }
    },
    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// RoleEdit.vue?2b1a3c02